import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleStack16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSpeechBubbleStack16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.564 9.538v-1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6.77a1 1 0 0 1 1 1v3.538a1 1 0 0 1-1 1H6.45l-.298.332-1.589 1.77zm5.205 0H6.897l-1.589 1.77c-.613.682-1.744.249-1.744-.668V9.538H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6.77a2 2 0 0 1 2 2v3.538a2 2 0 0 1-2 2M6 12h-.026l1.04-1h2.34l.283.25 1.744 1.536V11H13a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-.154V5H13a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-.62v1.34a.75.75 0 0 1-1.245.562L8.976 12z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleStack16);
